// extracted by mini-css-extract-plugin
export var auto = "_42-1";
export var spinner = "_42-0";